import React from 'react'
import styled from 'styled-components'
import { Box, Button, Icon, themeFontWeight } from '@elparking/components'

import { transparentize } from 'polished'
import { ARROW_HEIGHT_PX } from '../Map/PriceMarker/constants'

const fontFamily = props => props.theme.fontFamily
const gray20 = props => props.theme.colors.gray20 || 'gray'
const gray = props => props.theme.colors.gray || 'gray'
const mainColor = props => props.theme.colors.main || 'red'
const darkMainColor = props => props.theme.colors.darkMain || 'red'
const mainDarkColorTransparent = props => transparentize(0.6, props.theme.colors.darkMain || 'red')
const redColor = props => props.theme.colors.red || 'gray'
const cardBackground = props => props.unavailable ? 'rgba(0,0,0,0.05)' : 'transparent'
const mediaScreenMobile = props => `@media screen and (max-width: ${props.theme.screens.medium})`

export const ParkingImageBlock = styled.div`
    position: relative;
    min-width: 86px;
    margin-right: 16px;
`

export const ParkingMapImageBlock = styled.div`
    display: inline-block;
    height: 180px;
    width: 100%;
    position: relative;
`

export const AirportServiceBox = styled(Box)`
    border: 1px solid ${gray20};
    width: 100%;
    max-width: 266px;

    ${mediaScreenMobile} {
        max-width: none;
    }
`

export const AirportServiceTimeBox = styled(AirportServiceBox)`
    border-top: 0;
`

export const AirportMessageBlockDescription = styled.div`
    color: ${gray};
    font-weight: ${themeFontWeight('medium')};
    text-transform: uppercase;
    font-size: 12px;
    line-height: 18px;
`

export const AirportMessageBlockTransferTime = styled.div`
    font-size: 10px;
    font-weight: ${themeFontWeight('regular')};
`

export const AirportMessageBlockIconContent = styled.span`
    margin-top: 2px;
`

export const AirportMessageBlockIcon = (props) =>
    (<AirportMessageBlockIconContent><Icon {...props} /></AirportMessageBlockIconContent>)

export const ImageParking = styled.div`
    display: inline-block;
    background: url('/images/parking/default_gray_medium.webp');
    background-size: cover;
    background-position: center center;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    border-color: ${gray20};
    border-width: ${({border}) => border ? '1px' : '0'};
    border-style: solid;
    &:after {
        background: url('${(props) => props.background}');
        background-size: cover;
        background-position: center center;
        position: absolute;
        width: 100%;
        height: 100%;
        content: ' ';
    }
`

ImageParking.defaultProps = {
    background: null,
    boder: false,
}

export const MapCard = styled.div`
    cursor: pointer;
    background: white;
    font-family: ${fontFamily};
    border: 1px solid ${gray20};
    border-bottom: 0;

    &:after {
        position: absolute;
        left: calc(50% - ${ARROW_HEIGHT_PX}px);
        content: ' ';
        border-left: ${ARROW_HEIGHT_PX}px solid transparent;
        border-right: ${ARROW_HEIGHT_PX}px solid transparent;
        border-top: ${ARROW_HEIGHT_PX}px solid ${mainColor};
    }
`

export const ParkingNameBlock = styled.div`
    width: 100%;
    font-weight: ${themeFontWeight('book')};
    font-size: 16px;
    white-space: normal;
    line-height: 22px;
    margin-top: 4px;
    color: ${mainColor};
`

export const ParkingMapNameBlock = styled.div`
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: ${themeFontWeight('book')};
    font-size: 16px;
    white-space: nowrap;
    margin-top: 8px;
    color: ${mainColor};
`

export const PriceMessage = styled.span`
    font-weight: 400;
    line-height: 18px;
    font-weight: ${themeFontWeight('book')};
`

export const ParkingAddressBlock = styled.div`
    color: ${gray};
    white-space: normal;
    font-size: 12px;
    width: 100%;
    font-weight: ${themeFontWeight('regular')};
    line-height: 18px;

    ${mediaScreenMobile} {
        line-height: 22px;
        font-size: 14px;
    }
`

export const ParkingTextBlock = styled.div`
    float: right;
    width: 100%;
    font-size: 20px;
    font-weight: 400;
    font-size: 24px;
    line-height: 30px;
    position: flex;
    justify-content: center;

    ${mediaScreenMobile} {
        /* Fix for ios */
        max-width: calc(100% - 103px);
    }
`

export const Card = styled.div`
    padding: 1em 1em 0 1em;
    width: 100%;
    max-width:100%;
    color: ${gray};
    background: ${cardBackground};
    position: relative;

    &:after {
        content: ' ';
        display: block;
        height: 1px;
        margin-top: 1em;
        background: ${gray20};
    }
`

export const CardHeader = styled.div`
    display: flex;
`

export const CardFooter = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    width: calc(100% - 32px);
    margin-top: -36px;
    position: absolute;

    ${mediaScreenMobile} {
        width: 100%;
        margin-top: 16px;
        position: relative;
        display: block;
        margin-top: 16px;
    }
`

export const CardFooterForAirport = styled(CardFooter)`
    width: 100%;
    margin-top: 16px;
    position: relative;
`

export const ServiceMapContainer = styled.div`
    height: 36px;
    width: 100%;
`

export const ButtonContainer = styled.span`
    width: auto;
    display: inline-block;
    margin-left: auto;

    ${mediaScreenMobile} {
        margin-top: 0;
        width: 100%;
    }
`

export const Price = styled.span`
    font-weight: ${themeFontWeight('book')};
    font-size: 24px;
    line-height: 17px;
`

export const Currency = styled.span`
    font-weight: 300;
    font-size: 16px;
    margin-left: 5px;
    ${mediaScreenMobile} {
        font-weight: 400;
    }
`

export const PriceButton = styled.span`
    display: none;
    font-size: 20px;
    margin-right: 20px;
    ${mediaScreenMobile} {
        display: inline-block;
    }
`

export const ButtonPrice = styled(Button)`
    font-size: 14px;
    font-weight: ${themeFontWeight('book')};
    letter-spacing: 0px;
    padding: 0 16px;
    display: flex;
    align-items: center;

    &:hover {
        background: ${mainColor};
    }

    ${mediaScreenMobile} {
        margin-left: 0px;
    }
`

export const ButtonPriceInactive = styled(ButtonPrice)`
    background: transparent;
    color: ${darkMainColor};
    border: 1px solid ${mainColor};
    &:hover {
        color: ${mainColor};
        background: transparent;
    }
`

export const DistanceRightBlock = styled.div`
    font-size: 12px;
    font-weight: ${themeFontWeight('book')};
    line-height: 14px;
    display: inline-block;
    color: ${gray};
    margin-left: 8px;
    &:before {
        content: '·';
        margin-right: 8px;
    }
    ${mediaScreenMobile} {
        &:before {
            display: none;
        }
    }
 `

export const ParkingPriceBlock = styled.div`
    overflow: hidden;
    flex: 1 0 auto;
    min-width: 6em;
    max-width: 11em;
    padding-right: 16px;
    margin-right: 16px;
    border-right: 1px solid ${mainDarkColorTransparent};
`

export const ParkingMapTextBlock = styled.div`
    position: relative;
    max-width: 100%;
    margin: 10px 16px 10px 16px;
    color: ${gray};
`

export const Restriction = styled.div`
    display: inline-block;
    color: ${redColor};
    font-size: 10px;
    padding: 5px;
    border: 1px solid ${redColor};
    border-radius: 2px;
    min-width: 10px;
    min-height: 10px;
    margin-bottom: 10px;
    margin-right: 10px;
    font-weight: 300;
`

export const ParkingTextBlockHeader = styled.div`
    min-height: 72px;
    width: 100%;
    margin-top: -6px;
`
